module.exports = __webpack_public_path__ + "static/media/hexagon_base_blue.7e79fe56.svg";